module.exports = __webpack_public_path__ + "img/ja-deep-customer-empathy-thumbnail_new_logo.b9c12430.png";